import { Card, useMobile } from '@sonnen/web-ui';
import clsx from 'clsx';
import { useEffect, useMemo } from 'react';
import { useAppContext } from '../../AppContext/AppContext';
import HeatPumpStatusDE from '../../assets/images/heatPumpStatus-de.webp';
import HeatPumpStatusDE2 from '../../assets/images/heatPumpStatus-de@2.webp';
import HeatPumpStatus from '../../assets/images/heatPumpStatus-en.webp';
import HeatPumpStatus2 from '../../assets/images/heatPumpStatus-en@2.webp';
import SmartHeatingWithSolar from '../../assets/images/SmartHeatingWithSolar.webp';
import SmartHeatingWithSolar700 from '../../assets/images/SmartHeatingWithSolar700.webp';
import CroppedImage from '../../components/CroppedImage/CroppedImage';
import { CustomUSPCard } from '../../components/CustomUSPCard/CustomUSPCard';
import { OrderFlowPage } from '../../components/OrderFlowPage/OrderFlowPage';
import { USPTypography } from '../../components/USPTypography/USPTypography';
import { useTranslation } from '../../i18n/i18n';
import { OrderFlow } from '../../types';
import styles from './SelfConsumptionPlus.module.css';

export const SelfConsumptionPlus = () => {
  const { t, language } = useTranslation();
  const { setOrderFlow } = useAppContext();
  const mobile = useMobile();

  useEffect(() => {
    setOrderFlow(OrderFlow.selfConsumptionPlus);
  }, [setOrderFlow]);

  const imageSources = useMemo(() => {
    if (language === 'de') return [HeatPumpStatusDE, HeatPumpStatusDE2];
    return [HeatPumpStatus, HeatPumpStatus2];
  }, [language]);

  return (
    <OrderFlowPage dataTestId="self-consumption-plus" title={t('selfConsumptionPlus.pageTitle')}>
      <Card paddingSize="none" dataTestId="smart-heating-with-solar" className={styles.fill}>
        <Card paddingSize="md" className={clsx('gap', styles.fill)}>
          <USPTypography i18nScope="selfConsumptionPlus.usp1" />
          <USPTypography i18nScope="selfConsumptionPlus.usp2" header="H4" />
        </Card>
        <div className={styles.negativeMargin}>
          <CroppedImage
            height={mobile ? 300 : 500}
            src={SmartHeatingWithSolar700}
            srcSet={`${SmartHeatingWithSolar700} 1x, ${SmartHeatingWithSolar} 2x`}
            dataTestId="smart-heating-with-solar-image"
            alt={t('selfConsumptionPlus.smartHeatingWithSolarImageAlt')}
          />
        </div>
      </Card>

      <CustomUSPCard i18nScope="selfConsumptionPlus.sonnenAppCard" dataTestId="sonnen-app">
        <CroppedImage
          height={mobile ? 420 : 560}
          src={imageSources[0]}
          srcSet={`${imageSources[0]} 1x, ${imageSources[1]} 2x`}
          dataTestId="heat-pump-status-image"
          alt={t('selfConsumptionPlus.heatPumpStatusImageAlt')}
        />
      </CustomUSPCard>
    </OrderFlowPage>
  );
};

export default SelfConsumptionPlus;
